import React, { forwardRef } from 'react';
import { NumberFormatBase } from 'react-number-format';
import { removeNonDigitsFromString } from '../../utils/basic';

const identity = (v) => v;

const getCaretBoundary = (formattedValue) => {
  return Array(formattedValue.length + 1)
    .fill(0)
    .map(() => true);
};

const NumericTextField = forwardRef((props, ref) => (
  <NumberFormatBase
    {...props}
    getInputRef={ref}
    removeFormatting={identity}
    onValueChange={(values) => {
      props.onChange(values.formattedValue);
    }}
    format={(value) => removeNonDigitsFromString(value)}
    getCaretBoundary={getCaretBoundary}
  />
));

export default NumericTextField;